import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa47829e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Код", -1))
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-4 ModelField-colFirst" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1))
const _hoisted_7 = { class: "col-4 ModelField-col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1))
const _hoisted_9 = { class: "col-4 ModelField-colLast" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1))
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6 ModelField-colFirst" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Грузоподъемность (кг)", -1))
const _hoisted_15 = { class: "col-6 ModelField-colLast" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отступы", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-6 ModelField-colFirst" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вес реквизита (кг)", -1))
const _hoisted_20 = { class: "col-6 ModelField-colLast" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Рекомендуемый порог статнагрузки (м³) ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Информация", -1))
const _hoisted_23 = { class: "card card-body Container-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title Container-title" }, " Данные для расчета допустимого смещения ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Допускаемое смещение общего ЦТ груза в транспорте ", -1))
const _hoisted_26 = { class: "container-fluid" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-6 ModelField-colFirst" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Вес порожнего транспортного средства (кг) ", -1))
const _hoisted_30 = { class: "col-6 ModelField-colLast" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота ЦТ порожнего транспортного средства (мм) ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_DxTextBox, {
        class: "ModelField-control",
        stylingMode: "outlined",
        placeholder: "Код...",
        "show-clear-button": true,
        value: _ctx.modelLocal.code,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelLocal.code) = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_IntegerControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Длина...",
            min: 0,
            value: _ctx.modelLocal.length,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelLocal.length) = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_IntegerControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Ширина...",
            min: 0,
            value: _ctx.modelLocal.width,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelLocal.width) = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_IntegerControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Высота...",
            min: 0,
            value: _ctx.modelLocal.height,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelLocal.height) = $event))
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_DecimalControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Грузоподъемность...",
            decimalPoints: 2,
            min: 0,
            value: _ctx.modelLocal.loadCapacity,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelLocal.loadCapacity) = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_CatalogueSelectControl, {
            class: "ModelField-selectControl",
            stylingMode: "outlined",
            id: _ctx.modelLocal.gapId,
            "onUpdate:id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelLocal.gapId) = $event)),
            desc: _ctx.modelLocal.gapDescription,
            "onUpdate:desc": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelLocal.gapDescription) = $event)),
            displayDescField: "name",
            keyField: "id",
            catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
            hasEmptyValue: false,
            validationGroup: _ctx.validationGroup
          }, null, 8, ["id", "desc", "validationGroup"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_DecimalControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Вес реквизита...",
            decimalPoints: 3,
            min: 0,
            value: _ctx.modelLocal.requisiteWeight,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelLocal.requisiteWeight) = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_DecimalControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Рекомендуемый порог статнагрузки...",
            decimalPoints: 3,
            min: 0,
            max: 100,
            value: _ctx.modelLocal.loadStatThreshold,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelLocal.loadStatThreshold) = $event))
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_22,
      _createVNode(_component_DxTextArea, {
        class: "ModelField-control",
        stylingMode: "outlined",
        placeholder: "Информация",
        autoResizeEnabled: true,
        value: _ctx.modelLocal.info,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelLocal.info) = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", null, [
        _hoisted_25,
        _createVNode(_component_CatalogueSelectControl, {
          class: "ModelField-selectControl",
          stylingMode: "outlined",
          id: _ctx.modelLocal.displacementId,
          "onUpdate:id": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelLocal.displacementId) = $event)),
          desc: _ctx.modelLocal.displacementDescription,
          "onUpdate:desc": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelLocal.displacementDescription) = $event)),
          displayDescField: "name",
          keyField: "id",
          catalogueComponentName: "catalogues/DisplacementCatalogue/DisplacementCatalogue",
          hasEmptyValue: false
        }, null, 8, ["id", "desc"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_DecimalControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Вес порожнего ТС...",
              decimalPoints: 2,
              min: 0,
              value: _ctx.modelLocal.emptyWeight,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelLocal.emptyWeight) = $event))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Высота ЦТ порожнего ТС...",
              min: 0,
              value: _ctx.modelLocal.emptyHeight,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelLocal.emptyHeight) = $event))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ])
  ]))
}